var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4913 6.66393H18.0346L14.2266 0L12.4458 1.01764L15.6721 6.66393H4.84523L8.07256 1.01764L6.29066 0L2.4827 6.66393H1.02599C0.868312 6.66411 0.712793 6.70059 0.571488 6.77055C0.430182 6.84051 0.306886 6.94208 0.211157 7.06737C0.115428 7.19266 0.0498367 7.33831 0.0194689 7.49304C-0.0108988 7.64776 -0.00522764 7.8074 0.0360425 7.95958L2.9074 18.4889C3.02676 18.9226 3.28503 19.3053 3.64263 19.5782C4.00023 19.8511 4.43744 19.9993 4.88729 20H15.631C16.5522 20 17.3668 19.3794 17.6109 18.4869L20.4823 7.95856C20.524 7.80632 20.53 7.64649 20.4998 7.49156C20.4695 7.33663 20.4039 7.19079 20.3079 7.06544C20.212 6.94008 20.0883 6.83862 19.9467 6.76897C19.805 6.69932 19.6492 6.66337 19.4913 6.66393ZM15.63 17.9483H4.88729L2.36985 8.71563H18.1475L15.63 17.9483Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1811 10.7673H9.2328V15.8966H7.1811V10.7673ZM11.2845 10.7673H13.3362V15.8966H11.2845V10.7673Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.561d7589.svg";
export { ForwardRef as ReactComponent };